import apiClient from '../client'

export interface UserUpdatePayload {
  first_name?: string
  last_name?: string
  title?: string
  role_description?: string
  cell_phone?: string
  address?: string
  city?: string
  state?: string
  zip_code?: string
  can_manage_admins?: boolean
}

export interface UserResponse {
  id: string
  email: string
  role: string
  status: string
  first_name?: string
  last_name?: string
  title?: string
  account_number?: string
  role_description?: string
  cell_phone?: string
  address?: string
  city?: string
  state?: string
  zip_code?: string
  password_changed_at?: string | null
}

export interface ChangePasswordPayload {
  current_password: string
  new_password: string
}

export const usersApi = {
  async get(userId: string): Promise<UserResponse> {
    const { data } = await apiClient.get<UserResponse>(`/api/v1/users/${userId}`)
    return data
  },
  async list(role?: string): Promise<UserResponse[]> {
    const params: any = {}
    if (role) params.role = role
    const { data } = await apiClient.get<UserResponse[]>('/api/v1/users', { params })
    return Array.isArray(data) ? data : []
  },
  async update(userId: string, payload: UserUpdatePayload): Promise<UserResponse> {
    const { data } = await apiClient.put<UserResponse>(`/api/v1/users/${userId}`, payload)
    return data
  },
  async changePassword(payload: ChangePasswordPayload): Promise<{ message: string }> {
    const { data } = await apiClient.put<{ message: string }>('/api/v1/users/me/password', payload)
    return data
  },
}

